/* unplugin-vue-components disabled */import script from "./vipCard.vue?vue&type=script&setup=true&lang=js"
export * from "./vipCard.vue?vue&type=script&setup=true&lang=js"

import "./vipCard.vue?vue&type=style&index=0&id=03244d40&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03244d40"]])

export default __exports__